"use strict";const e=require("../../../../_virtual/canUseDom.js");Object.defineProperty(e.__exports,"__esModule",{value:!0});e.__exports.default=t;function t(){return!!(typeof window<"u"&&window.document&&window.document.createElement)}
